import React from 'react';
import { ThumbnailLoading } from '../../../../../shared/src/components/ThumbnailLoading';

export const ThumbnailInLoadingState = ({
    iconName = null,
}) => {
    return (
        <div className="casino-thumbnail">
            <ThumbnailLoading className="casino-thumbnail__img" iconName={iconName} />
        </div>
    );
};
